// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shopping-cart {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    margin-top: 91px;
    background-color: #f8f9fa;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-family: "Rigidica Text Regular", sans-serif;
}

.shopping-cart h2 {
    color: #333;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
}

.cart-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    margin-bottom: 10px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.cart-item-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
}

.cart-item-name {
    font-size: 16px;
    color: #333;
    margin-bottom: 5px;
}

.quantity-indicator {
    font-weight: normal;
    margin-right: 5px;
}

.quantity-x {
    font-size: 0.7em;
    vertical-align: middle;
    position: relative;
    top: -2px;
}

.cart-item-price {
    font-size: 14px;
    color: #666;
}

.cart-item-actions {
    display: flex;
    align-items: center;
}

.quantity-control {
    display: flex;
    align-items: center;
    margin-right: 15px;
}

.quantity-control button {
    background-color: #333;
    color: #fff;
    border: none;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.quantity-control span {
    margin: 0 10px;
    font-size: 16px;
}

.remove-button {
    background-color: #333;
    color: #fff;
    border: none;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.cart-item button:hover {
    background-color: #555;
}

.cart-summary {
    margin-top: 20px;
    text-align: right;
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.cart-subtotal,
.cart-shipping {
    font-size: 16px;
    color: #666;
    margin-bottom: 12px;
    padding-bottom: 8px;
}

.cart-total {
    margin-top: 15px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    padding-top: 15px;
    border-top: 1px dashed #ddd;
}

.empty-cart {
    text-align: center;
    padding: 20px;
}

.empty-cart p {
    margin-bottom: 20px;
    color: #666;
    font-size: 16px;
}

.continue-shopping-btn {
    background-color: #333;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-size: 16px;
}

.continue-shopping-btn:hover {
    background-color: #555;
}

/* CSS Media Queries */

@media (max-width: 1920px) {
    .shopping-cart {
        max-width: 100%;
    }
}

@media (max-width: 1536px) {
    .shopping-cart {
        margin-top: 50px;
    }
}

@media (max-width: 1280px) {
    .shopping-cart {
        margin-top: 40px;
    }
}

@media (max-width: 1024px) {
    .shopping-cart {
        margin-top: 30px;
    }
}

@media (max-width: 768px) {
    .shopping-cart {
        margin-top: 20px;
    }

    .cart-item {
        flex-direction: column;
        align-items: flex-start;
    }

    .cart-item-info {
        width: 100%;
        margin-bottom: 10px;
    }

    .cart-item-actions {
        width: 100%;
        justify-content: space-between;
    }
}

@media (max-width: 600px) {
    .shopping-cart {
        padding: 15px;
        margin-top: 10px;
    }

    .cart-item {
        padding: 10px;
    }

    .quantity-control {
        margin-right: 10px;
    }
}

@media (max-width: 599px) {
    .shopping-cart h2 {
        font-size: 20px;
    }

    .cart-summary {
        padding: 10px;
    }

    .cart-subtotal,
    .cart-shipping,
    .cart-total {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/ShoppingCart.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,sBAAsB;;AAEtB;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;;;QAGI,eAAe;IACnB;AACJ","sourcesContent":[".shopping-cart {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    margin-top: 91px;\n    background-color: #f8f9fa;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.shopping-cart h2 {\n    color: #333;\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.cart-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n    margin-bottom: 10px;\n    background-color: #fff;\n    border-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.cart-item-info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 50%;\n}\n\n.cart-item-name {\n    font-size: 16px;\n    color: #333;\n    margin-bottom: 5px;\n}\n\n.quantity-indicator {\n    font-weight: normal;\n    margin-right: 5px;\n}\n\n.quantity-x {\n    font-size: 0.7em;\n    vertical-align: middle;\n    position: relative;\n    top: -2px;\n}\n\n.cart-item-price {\n    font-size: 14px;\n    color: #666;\n}\n\n.cart-item-actions {\n    display: flex;\n    align-items: center;\n}\n\n.quantity-control {\n    display: flex;\n    align-items: center;\n    margin-right: 15px;\n}\n\n.quantity-control button {\n    background-color: #333;\n    color: #fff;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.quantity-control span {\n    margin: 0 10px;\n    font-size: 16px;\n}\n\n.remove-button {\n    background-color: #333;\n    color: #fff;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.cart-item button:hover {\n    background-color: #555;\n}\n\n.cart-summary {\n    margin-top: 20px;\n    text-align: right;\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 4px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.cart-subtotal,\n.cart-shipping {\n    font-size: 16px;\n    color: #666;\n    margin-bottom: 12px;\n    padding-bottom: 8px;\n}\n\n.cart-total {\n    margin-top: 15px;\n    font-size: 18px;\n    font-weight: bold;\n    color: #333;\n    padding-top: 15px;\n    border-top: 1px dashed #ddd;\n}\n\n.empty-cart {\n    text-align: center;\n    padding: 20px;\n}\n\n.empty-cart p {\n    margin-bottom: 20px;\n    color: #666;\n    font-size: 16px;\n}\n\n.continue-shopping-btn {\n    background-color: #333;\n    color: #fff;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    font-size: 16px;\n}\n\n.continue-shopping-btn:hover {\n    background-color: #555;\n}\n\n/* CSS Media Queries */\n\n@media (max-width: 1920px) {\n    .shopping-cart {\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 1536px) {\n    .shopping-cart {\n        margin-top: 50px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .shopping-cart {\n        margin-top: 40px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .shopping-cart {\n        margin-top: 30px;\n    }\n}\n\n@media (max-width: 768px) {\n    .shopping-cart {\n        margin-top: 20px;\n    }\n\n    .cart-item {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .cart-item-info {\n        width: 100%;\n        margin-bottom: 10px;\n    }\n\n    .cart-item-actions {\n        width: 100%;\n        justify-content: space-between;\n    }\n}\n\n@media (max-width: 600px) {\n    .shopping-cart {\n        padding: 15px;\n        margin-top: 10px;\n    }\n\n    .cart-item {\n        padding: 10px;\n    }\n\n    .quantity-control {\n        margin-right: 10px;\n    }\n}\n\n@media (max-width: 599px) {\n    .shopping-cart h2 {\n        font-size: 20px;\n    }\n\n    .cart-summary {\n        padding: 10px;\n    }\n\n    .cart-subtotal,\n    .cart-shipping,\n    .cart-total {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
